import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { Transition, useStyles } from './styles'

const PopupResultLeads = ({
  openDetailsPopup,
  onCloseDetailsPopupResult,
  detailsPopup,
  listResult,
  onOpenDetailsPopup,
  loadingPopups,
}) => {
  const classes = useStyles()

  const integrate = detailsPopup?.integrate
    ?.replace('[', '')
    ?.replace(']', '')
    .split(',')
  const noIntegrate = detailsPopup?.noIntegrate
    ?.replace('[', '')
    ?.replace(']', '')
    .split(',')
  const noAsign = detailsPopup?.noAsign
    ?.replace('[', '')
    ?.replace(']', '')
    .split(',')

  const listResultSplit = listResult
    ?.replace('[', '')
    ?.replace(']', '')
    .split(',')

  const listResultFortmat = listResultSplit
    ? JSON.parse(listResultSplit)
    : listResultSplit

  return (
    <Dialog
      open={openDetailsPopup}
      onClose={onCloseDetailsPopupResult}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent style={{ display: 'contents', flexWrap: 'wrap' }}>
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>
            Leads Integrados - (
            {integrate?.[0] === '' ? '0' : integrate?.length})
          </Typography>
          <Typography className={classes.subTitles}>
            {integrate?.map((id) => (
              <div
                className={classes.itemList}
                onClick={() => onOpenDetailsPopup(id)}
              >
                {id}
              </div>
            ))}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>
            Leads No integrados - (
            {noIntegrate?.[0] === '' ? '0' : noIntegrate?.length})
          </Typography>
          <Typography className={classes.subTitles}>
            {noIntegrate?.map((id) => (
              <div
                className={classes.itemList}
                onClick={() => onOpenDetailsPopup(id)}
              >
                {id}
              </div>
            ))}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>
            Leads No asignados - ({noAsign?.[0] === '' ? '0' : noAsign?.length})
          </Typography>
          <Typography className={classes.subTitles}>
            {noAsign?.map((id) => (
              <div
                className={classes.itemList}
                onClick={() => onOpenDetailsPopup(id)}
              >
                {id}
              </div>
            ))}
          </Typography>
        </div>
      </DialogContent>

      {loadingPopups === true ? (
        <DialogContent style={{ display: 'contents', flexWrap: 'wrap' }}>
          <div className={classes.titlesContainer}>
            <Typography className={classes.titles}>
              Detalle Lead - <strong>{listResultFortmat?.id}</strong>
            </Typography>
            <div className={classes.contentRowLead}>
              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    ¿Integrado?
                  </label>
                  {listResultFortmat?.integrado_impulsa === '1' ? 'SI' : 'NO'}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Departamento
                  </label>
                  {listResultFortmat?.departamento}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Ciudad
                  </label>
                  {listResultFortmat?.ciudad}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Campaña
                  </label>
                  {listResultFortmat?.campana}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Fuente
                  </label>
                  {listResultFortmat?.fuente}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Origen
                  </label>
                  {listResultFortmat?.origen}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Establecimiento
                  </label>
                  {listResultFortmat?.id_establecimiento}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Nombre Establecimiento
                  </label>
                  {listResultFortmat?.nombre_establecimiento}
                </div>
              </Typography>
            </div>
            <div className={classes.contentRowLead}>
              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Nombre Completo
                  </label>
                  {listResultFortmat?.nombre_completo}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Documento
                  </label>
                  {listResultFortmat?.documento}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Teléfono
                  </label>
                  {listResultFortmat?.telefono}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Correo Eléctronico
                  </label>
                  {listResultFortmat?.correo_electronico}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Fecha de creación
                  </label>
                  {listResultFortmat?.fecha_creacion}
                </div>
              </Typography>
              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Vehiculo
                  </label>
                  {listResultFortmat?.vehiculo}
                </div>
              </Typography>
              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>Marca</label>
                  {listResultFortmat?.marca}
                </div>
              </Typography>
              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Descripción Campaña
                  </label>
                  {listResultFortmat?.descripcion_campana === ''
                    ? 'N/A'
                    : listResultFortmat?.descripcion_campana}
                </div>
              </Typography>

              <Typography className={classes.contentPropertie}>
                <div>
                  <label className={classes.contentPropertieLabel}>
                    Descripción Contacto
                  </label>
                  {listResultFortmat?.descripcion_contacto === ''
                    ? 'N/A'
                    : listResultFortmat?.descripcion_campana}
                </div>
              </Typography>
            </div>
          </div>
        </DialogContent>
      ) : (
        ' '
      )}

      <DialogActions>
        <Button onClick={onCloseDetailsPopupResult} color="warning">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PopupResultLeads
